import { defineComponent, ref, onMounted } from 'vue'
import MapPage from '@/organizations/_default/map'
import FilterInfo from '@/organizations/cosmo/default/components/FilterInfo.vue'
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'
import { Filters } from '@/services/Filters.ts'
import ProductModal from '@/components/common/ProductModal.vue'
import functions from '@/organizations/cosmo/default/utils/functions.ts'
import { useStore } from 'vuex'
import Page from "@/services/Page.js"

export default defineComponent({
  extends: MapPage,
  components: {
    FilterInfo,
    CosmoHeader,
    CosmoFooter,
    ProductModal,
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)
    const store = useStore()

    // アプリ用に引き継ぐクエリを追加指定
    const queries = ['btn', 'sh', 'once', 'frm', 'skip', 'view']
    queries.forEach((query) => {
      Page.forwardQueries[query] = {}
    })
    
    const selectedSearchCondition = ref({})
    /**
     * コンポーネントの名前に合わせて変数名をproductModalRefとするが
     * モーダルに表示する内容は絞り込みの説明
     */
    const productModalRef = ref(null)

    /**
     * FileterInfoのクリックイベント
     * 共通のproductModalを利用するために、propsで設定する
     */
    const showProductModal = (searchConditionId) => {
      selectedSearchCondition.value = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, searchConditionId)
      productModalRef.value.open()

      storelocator.analytics.client?.send('SelectSearchCondition', {
        SearchConditionId: selectedSearchCondition.value.id,
        SearchConditionName: selectedSearchCondition.value.name,
      })
    }

    store.dispatch('setOrganizationActions', functions)


    onMounted(() => {
      // アプリ用のトラッキングイベントを送信
      if(storelocator.url_params.iframe !== undefined) {
        functions.sendScreenEvent('SSSENTAKU_MAP')

        // viewパラメータのついている場合はアプリ向けのボタンを表示させないためのクラスをbodyに追加
        if(storelocator.url_params.view !== undefined) {
          document.querySelector('body')?.classList.add('view-only-mode')
        }
      }

    })

    return {
      ...page,
      selectedSearchCondition,
      productModalRef,
      showProductModal,
    }
  }
})
